import { makeAutoObservable } from 'mobx'
import { NPS_PREVIEW_REPLY_SCORE } from 'pages/surveys/lib/npsCategories'
import { type IPreviewBubble } from 'pages/surveys/ui/SurveyView/ui/Preview/Preview'

export class NpsQuestionStore {
  companyName = ''
  error = ''

  constructor(initialCompanyName?: string | null) {
    this.companyName = initialCompanyName ?? ''
    makeAutoObservable(this)
  }

  private get _parts() {
    const trimmed = this.companyName.trim()
    return [
      { text: 'How likely are you to recommend ' },
      { text: trimmed || 'company or product name', isPlaceholder: !trimmed },
      { text: ' to your friends or colleagues? From 0 (not likely) to 10 (very likely)' },
    ]
  }

  get text(): string {
    return this._parts.map((part) => (part.isPlaceholder ? '' : part.text)).join('')
  }

  get previewBubble(): IPreviewBubble[] {
    return [
      {
        id: 'nps-question',
        direction: 'outbound',
        parts: this._parts,
      },
      {
        id: 'nps-question-reply',
        direction: 'inbound',
        parts: [{ text: String(NPS_PREVIEW_REPLY_SCORE) }],
      },
    ]
  }

  setCompanyName = (value: string) => {
    this.companyName = value
    if (this.error) this.error = ''
  }

  setError = (value: string) => {
    this.error = value
  }
}
